import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_FILES = `${REPORT}_SET_FILES`;
export const SYNC_AFTER_DELETE = `${REPORT}_SYNC_AFTER_DELETE`;
export const REMOVE_SHARED_OBJECT = `${REPORT}_REMOVE_SHARED_OBJECT`;



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/flow/actionTypes.js